export const DEFAULT_FLAG = '/icons/logo-shape-100x100.svg';
